import { useSelector } from 'react-redux';

import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import type { FacetStats } from '../interfaces/facets';
import { selectFacetStats } from '../selectors/facetStats';

export const useFacetStats = (facet: string): FacetStats | undefined =>
  useSelector<SpartacuxProductDiscoveryDomainState, FacetStats | undefined>(
    selectFacetStats(facet),
  );
